import { Pipe, PipeTransform } from '@angular/core';

import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';

import { QuoteStatusMetaPipe } from './quote-status.pipe';

@Pipe({
  name: 'proposalFormStatus',
  standalone: true,
})
export class ProposalFormStatusPipe
  extends QuoteStatusMetaPipe<{ label: string; icon: string }>
  implements PipeTransform
{
  map = new Map<QuoteStatus, { label: string; icon: string }>([
    [
      QUOTE_STATUSES.FormInitialized,
      { label: $localize`New proposal`, icon: 'application_new_thin' },
    ],
    [
      QUOTE_STATUSES.FormSent,
      { label: 'Proposal sent', icon: 'application_sent_thin' },
    ],
    [
      QUOTE_STATUSES.FormIncomplete,
      {
        label: $localize`Proposal in progress`,
        icon: 'application_progress_thin',
      },
    ],
    [
      QUOTE_STATUSES.FormComplete,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.OnHold,
      { label: $localize`Review required`, icon: 'under_review_thin' },
    ],
    [
      QUOTE_STATUSES.HealthEvaluationRequired,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.HealthEvaluationActive,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.Quoted,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.BrokerApproved,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.QuoteAccepted,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.AwaitingPayment,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [
      QUOTE_STATUSES.Complete,
      {
        label: $localize`Proposal complete`,
        icon: 'application_complete_thin',
      },
    ],
    [QUOTE_STATUSES.QuoteError, { label: 'Error', icon: '' }],
  ]);

  defaultValue = { label: 'Unknown', icon: 'help' };
}
